export default __webpack_public_path__ + "static/media/34.20392985.png";